export default __webpack_public_path__ + "static/media/EM0770.34I-21941_-14979_0.fb9630ea.jpg";